import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { AuthLayout, AuthField } from "@/components/AuthLayout";
import { useT } from "@/lib/i18n";

const ResetPasswordPage = () => {
  const t = useT();
  const navigate = useNavigate();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (p1.length < 6) { setErr(t("auth.err_min")); return; }
    if (p1 !== p2) { setErr(t("auth.err_match")); return; }
    setErr(null);
    setDone(true);
    setTimeout(() => navigate("/login"), 1500);
  };

  return (
    <AuthLayout
      testId="page-reset"
      title={t("auth.new_password")}
      subtitle={t("auth.new_password_sub")}
      footer={<><Link to="/login" className="text-[color:var(--gv-pink)]">{t("cta.back_to_login")}</Link></>}
    >
      {done ? (
        <div className="text-center py-4" data-testid="reset-success">
          <CheckCircle2 size={36} className="mx-auto text-[color:var(--gv-pink)] mb-4" />
          <div className="font-display text-[20px] text-[color:var(--gv-ink)] mb-2">{t("auth.password_updated")}</div>
          <div className="text-[13.5px] text-[color:var(--gv-ink)]/65">{t("auth.redirecting")}</div>
        </div>
      ) : (
        <form onSubmit={onSubmit}>
          <AuthField label={t("auth.new_password_label")}>
            <input type="password" required value={p1} onChange={(e) => setP1(e.target.value)} className="gv-input" placeholder={t("auth.min6")} data-testid="reset-p1" />
          </AuthField>
          <AuthField label={t("auth.confirm_password")} error={err}>
            <input type="password" required value={p2} onChange={(e) => setP2(e.target.value)} className="gv-input" placeholder={t("auth.repeat_password")} data-testid="reset-p2" />
          </AuthField>
          <button className="btn-primary w-full" data-testid="reset-submit">{t("cta.reset_password")} <ArrowRight size={16} /></button>
        </form>
      )}
    </AuthLayout>
  );
};

export default ResetPasswordPage;
